var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"c-floating-menu"},[_c('BCXCollapsible',{staticClass:"c-floating-drawer",attrs:{"is-opened":_vm.isOpened}},[_c('div',{staticClass:"c-floating-drawer__content"},[_vm._t("drawer")],2)]),_c('div',{staticClass:"c-floating-knob",on:{"click":_vm.toggleOpened}},[_vm._t("knob")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }